<template>
  <div class="relative flex flex-row items-center gap-[2px] px-6">
    <span aria-live="polite" aria-atomic="true" class="sr-only"> Page {{ currentPage }} of {{ pages }}</span>
    <span v-for="page in pages" :key="page" aria-hidden="true">
      <div v-if="page === currentPage" class="size-2 rounded-full bg-tertiary-container" />
      <div v-else class="size-2 rounded-full bg-surface-dim" />
    </span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  pages: number;
  currentPage: number;
}>();
</script>
